<template>
  <router-link
    class="result"
    :to="{name: 'product', params: { id: item.id }}"
    v-if="item.preview"
  >
    <figure>
      <div class="result-img">
        <img :src="checkImage(item.preview.image)" :alt="item.preview.header" />
      </div>
      <figcaption>
        <h3 class="result-header text-m">{{item.preview.header}}</h3>
        <h4 class="result-subheader text-m">{{item.preview.subheader}}</h4>
        <p v-if="item.preview.tags" class="text-s">{{displayTags(item.preview.tags)}}</p>
      </figcaption>
    </figure>
  </router-link>
</template>

<script>
export default {
  name: 'ProductPreview',
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    displayTags (tags) {
      return tags.join(' | ')
    },
    checkImage (url) {
      const fileExt = url.split('.').pop()
      return (['png', 'jpg', 'jpeg', 'gif'].indexOf(fileExt) !== -1 ? url : '/ui/img/no-photo.png')
    }
  }
}
</script>

<style scoped lang="scss">
.result {
  color: $color-text;
  display: block;
  text: {
    align: left;
    decoration: none;
  }

  .dark & {
    color: $text-light;
  }

  figure {
    margin: 0 0 $gap-lg 0;
    overflow: hidden;
    padding: 0;
    position: relative;
    width: 100%;

    @include screen('sm') {
      margin: 0;
    }
  }

  &-img {
    // background: $base-light2;
    border-bottom: 1px solid $bg-dark;
    overflow: hidden;
    position: relative;
    width: 100%;

    .hight-contrast & {
      border-color: $contrast-accent;
    }

    img {
      display: block;
      height: auto;
      width: 100%;
      max-width: 100%;
      transition: transform ($animation-duration / 2);
    }

  } // END .result-img;

  figcaption {
    margin: $gap-md 0;
  }

  &-header,
  &-subheader {
    margin: 0;
    transition: $transition;
  } // END .result-header, .result-subheader;

  &-header {
    text-transform: uppercase;
  } // END .result-header
  &-subheader {
    font-weight: normal;
  } // END .result-subheader;

  &:hover,&:focus {
    box-shadow: none;
    outline: 0 none;

    .result-header {
      color: $text-accent;

      .dark & {
        color: $contrast-text;
      }
    }

    .result-img {
      img {
        transform: scale(1.05);
      }
    } // END .result-img;

  } // END &:hover,&:focus;

  @include screen('sm') {
    margin: $gap-md 0;
    width: 30%;

    &-img {
      height: 0;
      padding-bottom: 100%;

      img {
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
      }

    } // END .result-img;

    &:hover,&:focus {

      .result-img {

        img {
          transform: translate(-50%, -50%) scale(1.05);
          transform-origin: center;
        }

      } // END .result-img;
    }

    &:nth-child(9n+2),
    &:nth-child(9n+3),
    &:nth-child(9n+8) {
      width: 60%;
    }
    &:nth-child(9n+9) {
      align-self: flex-end;
    }

  } // END @include screen('sm');

}
</style>
